/**
 * Created by Bart Decorte
 * Date: 2019-07-17
 * Time: 10:54
 */
import Column from "./Column";

class RelationColumn extends Column {

  constructor(params) {
    super(params);
    this.init();
  }

}

export default RelationColumn;


// WEBPACK FOOTER //
// ./resources/assets/js/columns/RelationColumn.js